import { useId } from "react";

import { ORGANIZER_DIRECTIONS_MAX_LENGTH } from "./OrganizerDirections.constants";
import {
  directionsLabel,
  directionsTextareaCss,
  directionsTextareaCssWrapper,
  paragraphCss,
} from "./OrganizerDirections.styles";

interface OrganizerDirectionsProps {
  name: string;
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isStudent: boolean;
}

const OrganizerDirections = ({
  name,
  value,
  handleChange,
  isStudent,
}: OrganizerDirectionsProps) => {
  const id = useId();
  const formattedName = name.toLowerCase().replace(/\s+/g, "-");
  const qaSelector = `exportables-${formattedName}-directions-input`;
  const isTextOverflowing = value.length > ORGANIZER_DIRECTIONS_MAX_LENGTH / 2;

  return (
    <div css={directionsTextareaCssWrapper}>
      <label htmlFor={id} css={directionsLabel}>
        Directions
      </label>
      {isStudent ? (
        <p css={paragraphCss(isTextOverflowing)}>{value}</p>
      ) : (
        <textarea
          id={id}
          data-qa-selector={qaSelector}
          value={value}
          onChange={handleChange}
          aria-label={`${name} organizer directions`}
          css={directionsTextareaCss(isTextOverflowing)}
          readOnly={isStudent}
          maxLength={ORGANIZER_DIRECTIONS_MAX_LENGTH}
        />
      )}
    </div>
  );
};

export default OrganizerDirections;
